// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const burgerButton = document.querySelector('.gh-burger');
    const main = document.querySelector('.gh-main');
    const foot = document.querySelector('.gh-foot');

    function isBurgerOpen() {
        return burgerButton.ariaExpanded === 'true';
    }

    function openBurger() {
        document.body.classList.add('gh-head-open');
        burgerButton.ariaExpanded = 'true';

        main.inert = true;
        main.ariaHidden = 'true';
        foot.inert = true;
        foot.ariaHidden = 'true';
    }

    function closeBurger() {
        document.body.classList.remove('gh-head-open');
        burgerButton.ariaExpanded = 'false';

        main.inert = false;
        main.ariaHidden = 'false';
        foot.inert = false;
        foot.ariaHidden = 'false';
    }

    burgerButton.addEventListener('click', function () {
        if (isBurgerOpen()) {
            closeBurger();
        } else {
            openBurger();
        }
    });

    const observer = new ResizeObserver(([body]) => {
        if (!isBurgerOpen()) {
            return;
        }
        if (body.borderBoxSize[0].inlineSize > 980) {
            closeBurger();
        }
    });
    observer.observe(document.body, { box: 'border-box' });
}
